var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobertBoschPortraitBrille(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1600 1600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h1600v1600H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4abb3",
    d: "M961.588 725.907l-2.37-13.04-12.446-69.344c17.78-26.67 40.893-64.6 53.933-100.754a174.5 174.5 0 0 0 9.484-38.523c0-2.37.593-4.74.593-6.52 0-13.63-2.964-26.077-11.26-34.967-17.187-18.967-36.747-11.854-54.527 5.333-31.41 29.634-57.49 88.307-57.49 88.307l30.82 108.458c.593 2.37.593 5.334 1.186 7.704a111.027 111.027 0 0 1 .593 24.3c-2.963 36.153-22.52 75.27-57.49 95.42-48.007 27.264-69.934 30.227-101.94 50.378-15.41 10.076-34.968 29.04-49.784 44.45-8.89 78.824-17.78 147.574-17.78 147.574h302.557l-33.485-307.002-.594-1.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e2e5",
    d: "M959.218 711.09l41.487-170.098c-13.04 35.56-36.153 74.084-53.933 100.754z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4abb3",
    d: "M572.514 264.007c-.166-.082.167.083 0 0-2.367 8.779-26.98 114.63-28.76 124.578.593 50.328 4.74 101.241 13.632 150.985 4.147 23.408 8.887 47.404 16.005 71.981l3.554 12.29 32.653 83.359c38.523-48.572 82.064-44.548 114.069-36.942l7.933 1.619a125.986 125.986 0 0 1 58.149 33.235l20.112-64.74s6.16-1.745 32.238-11.694c26.078-10.533 43.285-138.144 53.952-194.909 11.265-62.62 8.554-76.663 8.554-76.663s-.35-.142-.876-.35l43.042-42.895 53.935-30.28 13.483-25.885c-15.13-104.702-348.723-209.993-441.674 6.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1c7cc",
    d: "M643.508 479.72c-33.969-6.015-77.186 6.938-80.051 11.59l-3.978-15.779c7.866-11.853 21.92-25.771 35.651-27.783s48.543.781 76.478 9.689l-.783 3.837a23.592 23.592 0 0 1-27.317 18.446zM765.597 481.72c33.548-8.035 77.462 2.312 80.6 6.783l3.028-15.988c-8.56-11.362-23.42-24.415-37.248-25.602s-48.41 3.682-75.762 14.243l1.01 3.784a23.592 23.592 0 0 0 28.372 16.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e3033",
    d: "M246.886 1419.514c.11 1.797.168 3.594.311 5.393l.556 7.467v-28.827l11.953 196.013h405.197l-3.256-505.671s-5.442-174.878-4.342-221.63l-221.506 85.045c-49.87 38.91-108.87 127.844-140.33 182.721-35.139 62.691-52.825 210.262-48.583 279.428z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e2e5",
    d: "M975.365 957.31H687.194l-.555.305-100.416 56.283-43.883 408.742s413.12 149.576 444.592-87.528c27.661-209.226 59.19-338.39 59.195-338.418l-70.457-39.39-.305.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101112",
    fillRule: "evenodd",
    d: "M763.893 933.87l92.65 67.13-67.13 86.546 38.28 85.991-10.467 426.116-172.244.347 35.135-426.463 52.15-85.991-48.268-77.114z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#101112",
    d: "M297.81 1599.56l-11.44-185.3c-4.603-55.219-10.224-109.692-10.014-160.786a481.505 481.505 0 0 1 4.547-67.34 318.693 318.693 0 0 1 6.486-32.515L126.21 1599.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M894.82 1057.585S797.176 983.8 763.89 934.422c-2.219-3.329 72.677-8.877 129.819-47.156 63.244-42.164 78.718-64.355 78.718-64.355l59.422 80.998s-98.75 107.072-137.032 153.676"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M706.193 849.542c-.555 50.486 57.697 84.328 57.697 84.328l-100.416 123.163s-23.302-69.348-23.302-115.394 66.018-92.095 66.018-92.095"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43464a",
    d: "M1225.735 1599.56c-11.152-50.601-21.387-100.557-30.061-148.15q-2.6-14.84-3.96-29.862c-9.986-103.8 35.386-322.799 153.727-380.701l-319.328-184.029c-11.009 38.658-199.535 438.78-199.535 438.78L724 1599.56h175.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595e62",
    d: "M688.033 843.318l2.514-2.238a9.568 9.568 0 0 0-2.514 2.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#595e62",
    d: "M688.033 843.318l-23.578 21.002c-6.789-2.62-228.578 272.748-228.578 272.748l109.492-2.19-145.543 74.312c-10.323 70.713 87.321 252.594 166.356 390.37H684.97c9.648-74.34 19.793-163.173 25.346-243.923-27.435-85.495-43.71-486.522-22.283-512.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#656a6f",
    d: "M958.137 1136.424l-12.631-4.95 12.63 2.82 160.602 31.212s-20.672-264.723-20.346-267.033c0 0-79.173-68.8-125.965-75.563-.184 53.102-262.108 532.728-262.108 532.728l-45.847 243.841 235.16.081 198.76-296.923s-99.735-151.391-140.255-166.213z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2e3033",
    d: "M1154.52 1599.56h403.93l-66.342-383.889c-37.17-128.61-114.908-187.576-211.148-181.277-154.452 24.035-168.998 235.28-160.23 328.504 7.16 76.22 19.27 157.432 33.79 236.662z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e0e2e5",
    d: "M544.21 385.403c1.786-10.129 25.923-112.461 28.304-121.396-12.488 9.96-98.813 86.575-14.604 275.076-8.936-50.631-13.106-101.86-13.7-153.68zM1014.19 251.974v-.003c-84.639 12.036-112.58 102.458-112.58 102.458s3.577 16.085-8.34 79.82c-10.719 57.78-27.995 178.7-54.202 189.42-26.213 10.72-31.573 15.489-31.573 15.489l-18.463 62.544a128.193 128.193 0 0 0-59.568-34.547c-32.163-7.743-76.839-12.51-116.752 36.337l-35.768-80.713S523.38 765.934 527.78 851c4.132 79.899 66.811 153.044 196.765 176.182-28.671-66.843 164.05-54.954 206.37-166.254 15.776-41.494 11.63-106.743 4.53-132.65l-46.944-171.32s26.207-59.567 57.184-89.35c17.872-17.275 37.198-22.939 53.838-4.849 8.34 8.935 11.066 23.369 11.066 37.067 1.789-4.764 4.792-12.563 6.58-18.52 20.252-62.544 41.1-204.908-2.98-229.331z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 789.613,
    cy: 511.678,
    fill: "#c1c7cc",
    stroke: "#8a9097",
    strokeMiterlimit: 10,
    strokeWidth: 6.063,
    rx: 64.089,
    ry: 52.33
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.615,
    cy: 511.678,
    fill: "#c1c7cc",
    stroke: "#8a9097",
    strokeMiterlimit: 10,
    strokeWidth: 6.063,
    rx: 64.089,
    ry: 52.33
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#8a9097",
    strokeMiterlimit: 10,
    strokeWidth: 6.71,
    d: "M726.618 496.048c-17.003-8.671-33.012-7.812-48.3 0M963.9 458.354l-112.346 39.887"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a4abb3",
    d: "M946.772 643.523c17.78-26.67 40.893-64.6 53.933-100.754a174.5 174.5 0 0 0 9.484-38.523c0-2.37.593-4.74.593-6.52 0-13.63-2.964-26.077-11.26-34.967-17.187-18.967-36.747-11.854-54.527 5.333-31.41 29.634-57.49 88.307-57.49 88.307l30.82 108.458c.593 2.37 28.447-21.334 28.447-21.334z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobertBoschPortraitBrille);
export default __webpack_public_path__ + "static/media/robert-bosch-portrait-brille.7e6e9a8e.svg";
export { ForwardRef as ReactComponent };